import {
  Alert,
  Box,
  IconButton,
  InputAdornment,
  Snackbar,
  Typography,
} from "@mui/material";
import { PrimaryButton, PrimaryButtonText } from "../../components/ui/Button";
import { InputField } from "../../components/ui/Inputs";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { ReactComponent as EyeOffIcon } from "../../assets/icons/auth/eye-off.svg";
import { ReactComponent as EyeIcon } from "../../assets/icons/auth/eye.svg";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { SubmitHandler, useForm } from "react-hook-form";
import { ROUTES } from "../../routes/routerConfig";
import {
  clearAuth,
  authSelector,
  setPasswordType,
} from "../../services/redux/slices/authSlice";
import service from "../../services/api/service";
import regex from "../../data/regex";
import { encrypt, decrypt } from "../../utils/crypto";
import InputLabelComp from "../../components/ui/InputLabelComp";
import ButtonLoader from "../../components/ui/ButtonLoader";
import ReactGA from "react-ga4";
import { setStatusPopup } from "../../services/redux/slices/statusPopupSlice";
interface FormInputs {
  password: string;
  confirmPassword: string;
}

type props = {
  setNextStep: (step: string) => void;
};

const ForgotPassword = ({ setNextStep }: props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const {
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm<FormInputs>(); // Update to use FormInputs here
  const [severity, setSeverity] = useState<
    "error" | "warning" | "info" | "success"
  >("success");

  const [isLoading, setIsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const { userProfile, setPasswordKey, SetPasswordArray, resetToken } = useSelector(authSelector);
console.log(SetPasswordArray,"SetPasswordArray",userProfile)
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleSnackbarOpen = (message: string, severity: any) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
    setSeverity(severity);
  };

  const password = watch("password");

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleBack = () => setNextStep(ROUTES?.Login?.enterPassword?.path);

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    ReactGA.event({
      category: "Enter_ChangePassword_Continue",
      action: "Enter_ChangePassword_Continue",
    });

    let filterCifNumber = SetPasswordArray?.filter((item: any) =>  decrypt(item?.cifNumber) === decrypt(userProfile?.cifNumber));
    console.log(filterCifNumber,"filterCifNumber")
    setIsLoading(true);
    const payload = {
      cifNumber: decrypt(userProfile?.cifNumber) || userProfile?.phoneNumber,
      newPassword: encrypt(data.confirmPassword),
      password: encrypt(data.password),
      passwordType: "forgot",
      key: SetPasswordArray.length > 1
      ? filterCifNumber?.[0]?.id
      : setPasswordKey,
      resetToken: filterCifNumber?.[0]?.resetToken || SetPasswordArray?.[0]?.resetToken || resetToken,
    };
    

    service?.auth
      ?.setUserPassword(payload)
      .then((res: any) => {
        // handleSnackbarOpen("Your password is updated successfully","success");
        dispatch(setPasswordType(res?.data?.data?.passwordType));
        // navigate(ROUTES.Login.passwordCreated.locationPath, { replace: true });
        setNextStep(ROUTES?.Login?.passwordCreated?.path);
        setIsLoading(false);
      })
      .catch((error: any) => {
        // handleSnackbarOpen(error.response.data.message,"error");
        setIsLoading(false);
        dispatch(
          setStatusPopup({
            status: "error",
            message: error.response.data.message,
          })
        );
      });
  };

  return (
    <Box>
      <PrimaryButtonText
        startIcon={<ArrowBack color="inherit" fontSize="small" />}
        onClick={handleBack}
      >
        Back
      </PrimaryButtonText>
      <Box className="main-wrapper">
        <Box className="head-section">
          <Box className="heading">Forget Password ?</Box>
          <Box className="sub-heading">
            Set a new password to access your account securely.
          </Box>
        </Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          <InputLabelComp title="New Password" css={false} />
          <InputField
            type={showPassword ? "text" : "password"}
            required
            fullWidth
            autoFocus
            borderRadius="6px"
            placeholder="New password"
            {...register("password", {
              required: "Password is required",
              minLength: {
                value: 8,
                message: "Password must be at least 8 characters long",
              },
              maxLength: {
                value: 15,
                message: "Password must be at most 15 characters long",
              },
              pattern: {
                value: regex?.password,
                message:
                  "Password must contain one capital letter and symbol @$!%*?& or numbers",
              },
            })}
            error={!!errors.password}
            helperText={errors.password && errors.password.message}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <EyeIcon /> : <EyeOffIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{ mb: 2 }}
          />
          <InputLabelComp title="Confirm Password" css={false} />
          <InputField
            borderRadius="6px"
            autoComplete="off"
            type={showPassword ? "text" : "password"}
            required
            fullWidth
            placeholder="Confirm password"
            {...register("confirmPassword", {
              required: "Please confirm your password",
              validate: (value) =>
                value === password || "Passwords do not match",
            })}
            error={!!errors.confirmPassword}
            helperText={
              errors.confirmPassword && errors.confirmPassword.message
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <EyeIcon /> : <EyeOffIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Box
            component="ul"
            style={{
              marginTop: "15px",
              marginBottom: "15px",
              marginLeft: "-20px",
              fontSize: "15px",
            }}
          >
            <Box component="li">8 to 15 characters (no spaces)</Box>
            <Box component="li">
              Must include a combination of uppercase and lowercase letters,
              numbers, and special characters
            </Box>
          </Box>
          <PrimaryButton
            type="submit" // Change type to "submit"
            fullWidth
            disabled={isLoading}
          >
            <ButtonLoader title="Continue" isLoading={isLoading} />
          </PrimaryButton>
        </form>
      </Box>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackbarOpen}
        autoHideDuration={6000}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ForgotPassword;
